import { Experiment } from '@cian/experiments/ab';
import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { requestAuthentication } from '../../actions/authentication';
import { removeFavorite } from '../../actions/favoriteEntities';
import { ResultsMobile } from '../../components/ResultsMobile';
import { isFavoritesForAuthorizationEnabled } from '../../selectors/experiments/isFavoritesForAuthorizationEnabled';
import { IApplicationState } from '../../types/redux';
import { SavedSearches } from '../SavedSearches';
import { ETabType } from '../../types/filters';
import { LoadingView } from '../../components/SavedSearches/LoadingView';
import { selectActiveTab } from '../../selectors/activeTab';
import { EGetFavoriteEntitiesStatus } from '../../types/results';
import { PERS_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT } from '../../constants/experiments';

export const ResultsMobileContainer = () => {
  const results = useSelector((state: IApplicationState) => state.results);
  const page = useSelector((state: IApplicationState) => state.page);
  const favoritesForAuthorizationEnabled = useSelector(isFavoritesForAuthorizationEnabled);
  const { activeTab, isInitialized } = useSelector(selectActiveTab);

  const dispatch = useDispatch();

  const handleClick = React.useCallback(
    (entityId: number) => {
      dispatch(removeFavorite({ entityId }));
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [dispatch],
  );

  React.useEffect(() => {
    if (favoritesForAuthorizationEnabled) {
      dispatch(requestAuthentication());
    }
  }, [dispatch, favoritesForAuthorizationEnabled]);

  if (results.status === EGetFavoriteEntitiesStatus.Failed) {
    return null;
  }

  if (!isInitialized) {
    return <LoadingView />;
  }

  //если выбран таб "Поиски"
  if (activeTab === ETabType.SavedSearches) {
    return (
      <Experiment name={PERS_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT} group="B">
        <SavedSearches />
      </Experiment>
    );
  }

  return (
    <ResultsMobile
      results={results}
      page={page}
      isFavoritesForAuthorizationEnabled={favoritesForAuthorizationEnabled}
      removeFavorite={handleClick}
    />
  );
};
